import Vue from 'vue';
import Router from 'vue-router';
import { Auth } from "aws-amplify";
import store from "./store";

import AccountTemplate from "./template/Account";
import AuthencationTemplate from "./template/Authencation";
import Logout from "./components/Logout";

Vue.use(Router);

const confirmSignIn = (to, from, next) => {
  Auth.currentAuthenticatedUser()
    .then(user => {
      store.dispatch("auth/callSetAccountInfo", user);
      store.dispatch("auth/callSetSignedIn", true);
      Auth.currentCredentials()
        .then(credentials => {
          store.commit("auth/setUserId", credentials.identityId);
        })
        // eslint-disable-next-line no-console
        .catch(err => console.log(err));
      next();
    })
    .catch(err => {
      if (err) {
        store.dispatch("auth/callSetAccountInfo", null);
        store.dispatch("auth/callSetSignedIn", false);
        next("/auth");
      }
    });
};

export default new Router({
    mode: 'history',
    routes:[
        {
            path: '/',
            redirect: "/app"
        },
        {
            path: '/app',
            component: AccountTemplate,
            beforeEnter: confirmSignIn,
            redirect: "/app/manager",
            children: [
                {
                    path: 'add',
                    name: 'add',
                    component: () => import('./view/AddNewApp.vue')
                },
                {
                    path: 'edit',
                    name: 'edit',
                    component: () => import('./view/EditApp.vue')
                },
                {
                    path: ':role',
                    component: () => import('./view/AppData.vue')
                }
            ]
        },
        {
            path: "/auth",
            name: "authencation",
            component: AuthencationTemplate
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout
        }
    ]
})